import c from "../common";

export default {
  //Column
  Time: "Time",
  status: c.status.en,
  redeemed: "Redeemed",
  currency: "Currency",
  vendorName: c.vendor.en.uppercase + " Name",
  assistant: c.assistant.en.uppercase,
  consumerName: c.consumer.en.uppercase + " Name",
  consumerEmail: c.consumer.en.uppercase + " Email",
  consumerTel: c.consumer.en.uppercase + " Tel",

  totalAmount: "Total Amount(CAD)",
  totalQty: "Total Quantity",
  qty: "Quantity",
  download: c.download.en.uppercase,

  voucherName: c.voucher.en.uppercase + " Name",
  voucherId: c.voucher.en.uppercase + " ID",
  price: "Amount(CAD)",

  staffId: c.assistant.en.uppercase + " ID",

  reducePoint: "Point Reduced",
  //
  text1: "Redeem Record",
};
